import isEmpty from "lodash/isEmpty";

export const businessesConstants = {
    READ_MORE: 'Read More',
    ABOUT: 'About',
    SORT_BY: 'Sort by',
    SEARCH_YPO_ESTABLISHMENTS: 'Search for Hospitality Experiences',
    LOCATION: 'Location',
    SEARCH: 'Search',
    ASSET_SORT: 'Business Name (A-Z)',
    LOCATION_PLACEHOLDER: 'Search for a city, state or country',
    CURRENT_LOCATION: 'Current Location',
    SEARCH_ALLOW_LENGTH: 3,
    ROWS_PER_PAGE: 30,
    CURRENT_PAGE: 1,
    NO_RESULTS: 'Currently no YPO member-affiliated business found at this location.',
    REMOVE_FILTERS: 'Please remove some of the filters applied.',
    PAGINATION_LENGTH: 5,
    featureBusinesses: {
        MAX_ITEMS_FOR_CAROUSEL: 4,
        CAROUSEL_IMAGE_TOGGLE_RATE: 7000,
    },
    CUISINE_CATAGORY: 'Cuisine Category',
    PRICE: 'Price',
    DISTANCE: 'Distance',
    GEOLOCATION_BLOCKED:
        'Location access has been Blocked. Change your location settings in browser or select location manually.',
    GEOLOCATION_BLOCKED_TITLE: "Oops, we can't find your location",
    REFINE_BY: 'Refine by ',
    ESTABLISHMENT_COUNTER: 'establishmentsCounter',
    LOCATION_COUNTER: 'locationsCounter',
    EACH_OPTION_LENGTH: 42,
    YPO_MEMBER_OWNED: 'YPO member business',
    ASSET_RELATION_NONE: 'None',
    OWNERSHIP_TYPE: 'Ownership Type',
    OWNERSHIP_TYPES: ['Owner/Operator/Investor', 'None'],
    RELATIONSHIP_TYPES: ['Owner', 'Operator', 'Investor', 'None'],
    CLEAR_ALL_FILTERS: 'Clear',
    APPLY_FILTERS: 'Apply',
    MILES: 'miles',
    KILOMETERS: 'kilometers',
};

export const businessesSortOptions = [
    {
        label: 'Business Name (A-Z)',
        key: ' businessName_asc',
        sortField: 'name',
        direction: 'asc',
    },
    {
        label: 'Business Name (Z-A)',
        key: 'businessName_desc',
        sortField: 'name',
        direction: 'desc',
    },
    {
        label: 'Price Range $-$$$$',
        key: 'businessPrice_asc',
        sortField: 'priceRange',
        direction: 'asc',
    },
    {
        label: 'Price Range $$$$-$',
        key: 'businessPrice_desc',
        sortField: 'priceRange',
        direction: 'desc',
    },
];

export const businessesInformationConst = {
    COUNTRY: 'Country:',
    REGION: 'Region:',
    ESTABLISHMENT_TYPE: 'Establishment Type:',
    ACCOMMODATION_TYPE: 'Accommodation Type:',
    CUISINE_TYPE: 'Cuisine Type:',
    DESTINATION_RESTAURANT: 'Destination Restaurant:',
    PRICE: 'Price:',
    HOTEL_CLASS_TYPE: 'Hotel Class Type:',
    WEBSITE_URL: 'Website Url:',
    DISCOUNT_CODE: 'Discount Code:',
    TELEPHONE: 'Telephone:',
    CONTACT_NAME: 'Contact Name for Reservations/Further Information:',
    CONTACT_PHONE_NUMBER: 'Contact Phone Number:',
    CONTACT_EMAIL: 'Contact Email:',
    ACCOMMODATION: 'Accommodation',
    DINING: 'Dining',
    MEMBERS: 'Member(s):',
};

export const businessFilters = {
    accommodationTypes: 'accommodationType',
    cuisineTypes: 'cuisineType',
    establishments: 'establishmentType',
    hotelClassTypes: 'hotelClassType',
    prices: 'priceRange',
    starRatings: 'michelinStarRating',
    ownershipTypes: 'personAssetRelation',
    distances: 'distanceMiles',
};

export const filterMethods = {
    toggleColor(filter, item) {
        if (this.filters[filter].includes(item)) {
            this.filters[filter].splice(this.filters[filter].indexOf(item), 1);
        } else {
            this.filters[filter].push(item);
        }
    },
    checkDisabled(filter, item) {
        if (!isEmpty(this.filtersEnabled) && !isEmpty(this.filtersEnabled[filter])) {
            return !this.filtersEnabled[filter].includes(item); 
        }
        return false;
    },
    checkDisabledForCuisine(filter, item) {
        if (!isEmpty(this.filtersEnabled) && !isEmpty(this.filtersEnabled[filter])) {
            return !this.filtersEnabled[filter].join(',').includes(item);
        }
        return false;
    },
    checkDisabledForOwnertype(filter, item) {
        if (!isEmpty(this.filtersEnabled) && !isEmpty(this.filtersEnabled.ownershipTypes)) {
            return !this.filtersEnabled.ownershipTypes.some(res => res.includes(item)); 
        }
        return false;
    },
    resetFilters() {
        this.filters = {
            establishments: [],
            cuisineTypes: [],
            accommodationTypes: [],
            starRatings: [],
            prices: [],
            hotelClassTypes: [],
            ownershipTypes: [],
            distances: [],
        };
    },
};

export const emptyFilters = {
    establishments: [],
    cuisineTypes: [],
    accommodationTypes: [],
    starRatings: [],
    prices: [],
    hotelClassTypes: [],
    ownershipTypes: [],
    distances: [],
};
